var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface114983447"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(31.37255%,85.09804%,8.627451%)",
      fillOpacity: 1
    },
    d: "M 0.988281 32 C 0.988281 14.875 14.875 0.988281 32 0.988281 C 49.125 0.988281 63.011719 14.875 63.011719 32 C 63.011719 49.125 49.125 63.011719 32 63.011719 C 14.875 63.011719 0.988281 49.125 0.988281 32 Z M 0.988281 32 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 45.625 16.5 L 18.375 16.5 C 17.335938 16.5 16.5 17.335938 16.5 18.375 L 16.5 45.625 C 16.5 46.664062 17.335938 47.5 18.375 47.5 L 45.625 47.5 C 46.664062 47.5 47.5 46.664062 47.5 45.625 L 47.5 18.375 C 47.5 17.335938 46.664062 16.5 45.625 16.5 Z M 45.625 16.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(31.37255%,85.09804%,8.627451%)",
      fillOpacity: 1
    },
    d: "M 49.074219 21.613281 C 48.351562 19.726562 46.863281 20.023438 45.25 20.351562 C 44.289062 20.550781 40 21.800781 33.238281 28.949219 C 30.425781 31.914062 28.574219 34.273438 27.351562 36.074219 C 26.601562 35.164062 25.75 34.175781 24.851562 33.289062 C 22.085938 30.523438 19 28.625 18.875 28.550781 C 17.585938 27.761719 15.898438 28.164062 15.101562 29.460938 C 14.3125 30.75 14.710938 32.4375 16 33.238281 C 16.023438 33.25 18.675781 34.886719 20.949219 37.175781 C 23.273438 39.5 25.386719 42.648438 25.414062 42.6875 C 25.925781 43.460938 26.789062 43.914062 27.699219 43.914062 C 27.851562 43.914062 28.011719 43.898438 28.175781 43.875 C 29.25 43.6875 30.101562 42.886719 30.363281 41.835938 C 30.375 41.8125 31.460938 38.800781 37.199219 32.75 C 41.824219 27.863281 44.914062 26.3125 45.988281 25.886719 C 46 25.886719 46 25.886719 46.023438 25.886719 C 46.023438 25.886719 46.0625 25.875 46.125 25.835938 C 46.3125 25.761719 46.414062 25.738281 46.414062 25.738281 C 46.363281 25.75 46.335938 25.75 46.335938 25.75 L 46.335938 25.738281 C 46.835938 25.523438 47.761719 25.125 47.773438 25.113281 C 49.164062 24.511719 49.625 23.011719 49.074219 21.613281 Z M 49.074219 21.613281 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickGreen);
export default __webpack_public_path__ + "static/media/tick-green.cb8cc77729a97dda2952548a18462410.svg";
export { ForwardRef as ReactComponent };